import { render, staticRenderFns } from "./UnconfirmedChoir.vue?vue&type=template&id=3fb6996a&scoped=true&"
import script from "./UnconfirmedChoir.vue?vue&type=script&lang=ts&"
export * from "./UnconfirmedChoir.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb6996a",
  null
  
)

export default component.exports